<template>
  <tr>
    <td
      class="position-relative"
      :class="{
        'pl-8': isChild,
        'horizontal-line': isChild,
        'vertical-line': account.children?.length || (isChild && !isLast),
        'extended-vertical-line': isChild && !isLast,
      }"
    >
      {{ account.name }}
    </td>
    <td
      v-for="(balance, index) in account.balance"
      :key="index"
      class="text-nowrap align-middle"
      v-b-tooltip.hover.top="{
        title: getGrowthRateDescription(index),
        variant: getGrowthRateTooltipVariant(index),
      }"
    >
      {{ toCurrency(balance.balance) }} |
      <span :style="{ color: getGrowthRateColor(index) }">
        {{ toPercent(balance.growthRate) }}
      </span>
    </td>
  </tr>
</template>

<script>
export default {
  name: "PlanAccountRow",
  props: {
    account: {
      type: Object,
      required: true,
    },
    isChild: {
      type: Boolean,
      default: false,
    },
    isLast: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getGrowthRateColor(index) {
      const current = this.account.balance[index].growthRate;
      const previous =
        index > 0 ? this.account.balance[index - 1].growthRate : 0;
      return current >= previous ? "green" : "red";
    },
    getGrowthRateDescription(index) {
      const current = this.account.balance[index].growthRate;
      const previous =
        index > 0 ? this.account.balance[index - 1].growthRate : 0;
      const text = `${this.toPercent(current)} em relação ao mês anterior`;
      return current >= previous ? `+${text}` : text;
    },
    getGrowthRateTooltipVariant(index) {
      const current = this.account.balance[index].growthRate;
      const previous =
        index > 0 ? this.account.balance[index - 1].growthRate : 0;
      return current >= previous ? "success" : "danger";
    },
    toCurrency(value, decimals = 2) {
      return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: decimals,
      }).format(value || 0);
    },
    toPercent(value, decimals = 2) {
      const percentage = new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: decimals,
      }).format(value || 0);
      return `${percentage}%`;
    },
  },
};
</script>

<style>
.horizontal-line::before {
  content: "";
  position: absolute;
  width: 1px;
  top: 15px;
  left: 17px;
  height: 9px;
  transform: rotate(90deg);
  background-color: rgb(187, 181, 181);
}

.vertical-line::after {
  content: "";
  position: absolute;
  top: 26px;
  left: 13px;
  width: 1px;
  height: 33px;
  background-color: rgb(187, 181, 181);
}

.extended-vertical-line::after {
  top: 20px;
  height: 38px;
}
</style>
